<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="table-responsive">
    <b-table
      class="table table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
      fixed
      show-empty
      responsive
      tbody-tr-class="one-line-td-table"
      :busy="loading"
      :fields="fields"
      :items="canRead(access) ? data : []"
      :sort-by.sync="localSortBy"
      :sort-desc.sync="localSortDesc"
      @sort-changed="onSortChanged"
    >
      <template v-slot:table-busy="">
        <div class="text-center text-danger my-2">
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </div>
      </template>
      <template v-slot:head(lndmName)="header">
        <span class="sortable-label">
          {{ header.label }}
          <span class="sort-icons">
            <span :class="getSortClass('lndmName', false)">&#9650;</span>
            <span :class="getSortClass('lndmName', true)">&#9660;</span>
          </span>
        </span>
      </template>
      <template v-slot:head(lndmType)="header">
        <span class="sortable-label">
          {{ header.label }}
          <span class="sort-icons">
            <span :class="getSortClass('lndmType', false)">&#9650;</span>
            <span :class="getSortClass('lndmType', true)">&#9660;</span>
          </span>
        </span>
      </template>
      <template v-slot:cell(action)="row">
        <div class="text-center action-buttons">
          <button
            class="btn btn-sm btn-outline-mantraz mr-1"
            type="button"
            @click="onActionZoom(row.item)"
          >
            Zoom
          </button>
          <landmark-edit
            :access="access"
            :landmark="row.item"
            @onDeleteClicked="onActionDelete"
            @onEditClicked="onActionEdit"
          />
        </div>
      </template>
      <template v-slot:cell(lndmDescription)="row">
        {{ formatDescription(row.value) }}
      </template>
      <template v-slot:cell(lndmType)="row">
        {{ formatType(row.value) }}
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalSize"
      @change="onPaginationChanged"
    ></b-pagination>
  </div>
</template>

<script>
import LandmarkEdit from './Edit';

export default {
  name: 'LandmarkList',
  components: { LandmarkEdit },
  props: {
    access: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        pageSize: 20,
        totalSize: 0,
      }),
    },
    sortBy: {
      type: String,
      default: '',
    },
    sortDesc: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSortBy: this.sortBy,
      localSortDesc: this.sortDesc,
      fields: [
        {
          key: 'lndmName', label: 'Name', class: 'text-left', sortable: true,
        },
        { key: 'lndmDescription', label: 'Description', class: 'text-left' },
        {
          key: 'lndmType', label: 'Type', class: 'text-center', sortable: true,
        },
        { key: 'lndmLatitude', label: 'Latitude', class: 'text-center' },
        { key: 'lndmLongitude', label: 'Longitude', class: 'text-center' },
        { key: 'action', label: '', class: 'text-center' },
      ],
    };
  },
  watch: {
    sortBy(nextValue) {
      this.localSortBy = nextValue;
    },
    sortDesc(nextValue) {
      this.localSortDesc = nextValue;
    },
  },
  methods: {
    formatDescription(value) {
      if (value === null || value === undefined) return '-';
      const text = String(value).trim();
      if (!text) return '-';
      if (text.length <= 100) return text;
      return `${text.slice(0, 100)}...`;
    },
    getSortClass(key, isDesc) {
      if (this.localSortBy !== key) return 'sort-icon';
      return this.localSortDesc === isDesc ? 'sort-icon is-active' : 'sort-icon';
    },
    formatType(value) {
      if (!value) return '';
      return String(value).toUpperCase();
    },
    onPaginationChanged(page) {
      this.$emit('onPageChanged', page);
    },
    onSortChanged(ctx) {
      this.$emit('onSortChanged', ctx);
    },
    onActionDelete(data) {
      this.$emit('onActionDelete', data);
    },
    onActionEdit(data) {
      this.$emit('onActionEdit', data);
    },
    onActionZoom(data) {
      this.$emit('onActionZoom', data);
    },
  },
};
</script>

<style scoped>
.sortable-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.sort-icons {
  display: inline-flex;
  flex-direction: column;
  line-height: 0.8;
}

.sort-icon {
  color: #9aa0a6;
  font-size: 10px;
}

.sort-icon.is-active {
  color: #1b5e20;
}

.action-buttons {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
</style>
